import api, { parseErrorMessage } from 'api'
import { isAxiosError } from 'axios'

export type ConvertColumbiaTimesheetToVndlyUploadParams = {
  startDate: string
  endDate: string
  timesheet: File
}

export type ConvertColumbiaTimesheetToVndlyUploadResponse = {
  blob: Blob
  filename: string
}

export const convertColumbiaTimesheetToVndlyUpload = async ({
  startDate,
  endDate,
  timesheet,
}: ConvertColumbiaTimesheetToVndlyUploadParams): Promise<ConvertColumbiaTimesheetToVndlyUploadResponse> => {
  const formData = new FormData()
  formData.append('timesheet', timesheet)

  try {
    const response = await api.post<Blob>(
      '/admin/vndly/columbia/timesheet/vndly_upload',
      formData,
      {
        params: {
          startDate,
          endDate,
        },
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'text/csv',
        },
        responseType: 'blob',
      }
    )

    const contentDisposition = response.headers['content-disposition']
    const filenameMatch = contentDisposition?.match(/filename="?([^"]+)"?/)

    return {
      blob: response.data,
      filename:
        filenameMatch?.[1] ?? `UPLOAD_Columbia_Time_Week_End_${endDate}.csv`,
    }
  } catch (err) {
    throw new Error(await parseConvertError(err))
  }
}

const parseConvertError = async (err: unknown): Promise<string> => {
  if (isAxiosError(err) && err.response?.data instanceof Blob) {
    const text = await err.response.data.text()
    let parsed: unknown
    try {
      parsed = JSON.parse(text)
    } catch {
      return text || err.message
    }
    if (parsed && typeof parsed === 'object' && 'message' in parsed) {
      err.response.data = parsed
      return parseErrorMessage(err) ?? JSON.stringify(parsed, null, 2)
    }
    return JSON.stringify(parsed, null, 2)
  }
  return parseErrorMessage(err) ?? 'Conversion failed'
}
